/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue } from 'vue-property-decorator'
import { getRolesList, getRoleUser, setUserRole } from '@/api/authority'

@Component({
  components: {}
})
export default class RoleManagement extends Vue {
  // ------ 变量 ------
  editRoleValue = -1 // 修改用户角色
  editRoleAuthorityShow = false
  page = 1 // 分页
  total = 0
  limit = 20
  roleList: any = []
  userList: Array<any> = []
  editUserRoleId = ''
  activeRoleId: number = undefined
  editUsering: any = {}
  loading = false
  serachName = '' // 员工姓名搜索
  filterPopoverShow = false
  timer = null


  // ------ 生命周期 ------
  created() {
    this.initRoleList()
  }

  // ------ 方法 ------
  async initRoleList() {
    const data: any = await getRolesList()
    this.roleList = data
    this.getAllUserList()
  }
  async initUserList() {
    this.loading = true


    const data: any = await getRoleUser({
      page: this.page,
      limit: 20,
      roleId: this.activeRoleId ? this.activeRoleId : 0,
      realName: this.serachName
    })
    this.userList = data.userList
    this.total = data.allNum
    this.filterPopoverShow = false
    this.$nextTick(() => {

      (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.scrollTop = 0;
    });
    this.loading = false

  }
  clickRole(id: number) {
    this.page = 1
    this.activeRoleId = id
    this.initUserList()
  }

  clickEditRoleAuthority(item: any) {
    this.editUsering = item
    this.editUserRoleId = item.role.id
    this.editRoleAuthorityShow = true

  }
  async confrimEditRoleAuthority() {
    this.editRoleAuthorityShow = false
    await setUserRole({ userIds: [this.editUsering.id], roleId: this.editUserRoleId })
    this.$message.success('修改成功')
    this.initUserList()
  }
  // 获取全部人员
  getAllUserList() {
    this.activeRoleId = undefined
    this.initUserList()
  }

  changePage(val: number) {
    if (this.timer !== null) clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.page = val
      this.initUserList()
    }, 1000)
  }

}
